document.querySelectorAll('[data-extra-product]').forEach((root) => {
  const select = root.querySelector('[data-extra-variant]');
  select?.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    root.querySelector('[data-extra-price]').textContent = option.dataset.price;
    const button = root.querySelector('[data-extra-submit]');
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });
});
document.querySelectorAll('[data-sticker-picker]').forEach((root) => {
  const fields = [...root.querySelectorAll('[data-mix-qty]')];
  const button = root.querySelector('[data-mix-add]');
  const message = root.querySelector('[data-mix-message]');
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' });
  let busy = false;
  const quantity = (field) => Math.max(0, Math.min(99, Math.floor(Number(field.value) || 0)));
  const update = () => {
    const count = fields.reduce((n, field) => n + quantity(field), 0);
    const total = fields.reduce((n, field) => n + quantity(field) * Number(field.dataset.price), 0);
    root.querySelector('[data-mix-count]').textContent = `${count} sticker${count === 1 ? '' : 's'} selected`;
    root.querySelector('[data-mix-total]').textContent = formatter.format(total / 100);
    button.disabled = busy || count === 0;
    button.textContent = busy ? 'Adding…' : `Add my picks${count ? ' · ' + formatter.format(total / 100) : ''}`;
  };
  root.querySelectorAll('[data-mix-controls]').forEach(el => { el.hidden = false; });
  root.querySelectorAll('[data-mix-step]').forEach(step => {
    step.addEventListener('click', () => {
      const field = step.closest('.nt-mix-stepper').querySelector('[data-mix-qty]');
      if (field.disabled) return;
      field.value = Math.max(0, Math.min(99, quantity(field) + Number(step.dataset.mixStep)));
      update();
    });
  });
  fields.forEach(field => {
    field.addEventListener('input', update);
    field.addEventListener('change', () => { field.value = quantity(field); update(); });
  });
  button.addEventListener('click', async () => {
    if (busy) return;
    const items = fields.filter(field => !field.disabled && quantity(field) > 0).map(field => ({ id: field.dataset.variant, quantity: quantity(field) }));
    if (!items.length) return;
    busy = true; message.textContent = ''; update();
    try {
      const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({items}) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Could not add your picks. Please check your cart before trying again.');
      window.NaughtyTopsFunnel?.emit('sticker_mix_added', {quantity: items.reduce((n,item)=>n+item.quantity,0), currency: root.dataset.currency});
      window.location.assign(root.dataset.cartUrl);
    } catch (error) {
      message.textContent = (error.message || 'Unable to add your picks.') + ' Please review your cart before trying again.';
      busy = false; update();
    }
  });
  update();
});

(() => {
  const text = document.querySelector('[data-quick-config]')?.dataset;
  if (!text) return;
  const cartUrl = text.ntCartUrl;
  let queue = Promise.resolve();
  const pending = new Set();
  let toastTimer;
  const notify = (message, persistent = false) => {
    document.querySelector('.nt-quick-toast')?.remove();
    const box = document.createElement('div');
    box.className = 'nt-quick-toast';
    box.setAttribute('role', 'status');
    const copy = document.createElement('span');
    copy.textContent = message;
    const link = document.createElement('a');
    link.href = cartUrl;
    link.textContent = text.ntCartLabel;
    const close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', text.ntDismiss);
    close.textContent = '×';
    close.addEventListener('click', () => box.remove());
    box.append(copy, link, close);
    document.body.append(box);
    clearTimeout(toastTimer);
    if (!persistent) toastTimer = setTimeout(() => box.remove(), 5000);
  };
  const markPending = () => {
    document.querySelectorAll('[data-quick-add]').forEach(form => {
      const button = form.querySelector('[data-quick-button]');
      if (pending.has(form.getAttribute('id'))) { button.disabled = true; button.textContent = button.dataset.adding; }
    });
    document.querySelectorAll('[name=checkout], [data-cart-quantity]').forEach(el => { el.disabled = pending.size > 0; });
  };
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-quick-variant]')) return;
    const select = event.target;
    const option = select.selectedOptions[0];
    const form = select.closest('[data-quick-add]');
    const button = form.querySelector('[data-quick-button]');
    button.dataset.idle = option.dataset.label;
    button.textContent = option.dataset.label;
    button.setAttribute('aria-label', `${form.dataset.title} · ${option.dataset.label}`);
    button.disabled = option.dataset.available !== 'true' || pending.has(form.getAttribute('id'));
  });
  const perform = async (task) => {
    const cart = document.querySelector('[data-cart-section]');
    const button = document.getElementById(task.id)?.querySelector('[data-quick-button]');
    const oldY = button?.getBoundingClientRect().top;
    const payload = task.payload;
    const sectionId = cart?.dataset.cartSection || 'cart-main';
    payload.sections = [sectionId];
    payload.sections_url = cartUrl;
    try {
      const response = await fetch(`${cartUrl}/${task.action}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || text.ntError);
      if (cart) {
        const parsed = new DOMParser().parseFromString(result.sections?.[cart.dataset.cartSection] || '', 'text/html');
        const replacement = parsed.querySelector('[data-cart-section]');
        if (!replacement) { window.location.assign(cartUrl); return; }
        const openDetails = [...document.querySelectorAll('.nt-addon-details[open]')].map(el => el.id);
        const selections = [...document.querySelectorAll('[data-quick-variant]')].map(el => [el.id, el.value]);
        cart.replaceWith(replacement);
        openDetails.forEach(id => { const detail = document.getElementById(id); if (detail) detail.open = true; });
        selections.forEach(([id, value]) => {
          const select = document.getElementById(id);
          if (select && [...select.options].some(option => option.value === value && !option.disabled)) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        document.querySelectorAll('.cart-count').forEach(el => { el.textContent = replacement.dataset.itemCount; });
        const target = document.getElementById(task.id)?.querySelector('[data-quick-button]');
        if (target && oldY !== undefined) {
          target.focus({ preventScroll: true });
          window.scrollBy({ top: target.getBoundingClientRect().top - oldY, behavior: 'instant' });
        }
      } else {
        const rendered = new DOMParser().parseFromString(result.sections?.[sectionId] || '', 'text/html');
        const count = rendered.querySelector('[data-cart-section]')?.dataset.itemCount;
        document.querySelectorAll('.cart-count').forEach(el => { el.textContent = count || String(Number(el.textContent) + 1); });
        const status = document.getElementById(task.id)?.querySelector('[data-quick-status]');
        if (status) status.textContent = text.ntAdded;
      }
      notify(task.action === 'add' ? text.ntAdded : text.ntUpdated);
      if (task.action === 'add') window.NaughtyTopsFunnel?.emit('extra_quick_added', { variant_id: task.payload.items[0].id, source: cart ? 'cart' : 'collection', quantity: 1 });
    } catch (error) {
      notify(`${error.message || text.ntError} ${text.ntError}`, true);
    } finally {
      pending.delete(task.id);
      const currentButton = document.getElementById(task.id)?.querySelector('[data-quick-button]');
      if (currentButton) { currentButton.disabled = false; currentButton.textContent = currentButton.dataset.idle; }
      markPending();
    }
  };
  const enqueue = (task) => {
    if (pending.has(task.id)) return;
    pending.add(task.id);
    markPending();
    queue = queue.then(() => perform(task));
  };
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-quick-add]');
    if (!form) return;
    event.preventDefault();
    if (pending.has(form.getAttribute('id'))) return;
    const button = form.querySelector('[data-quick-button]');
    if (button.disabled) return;
    const data = new FormData(form);
    enqueue({ id: form.getAttribute('id'), action: 'add', payload: { items: [{ id: data.get('id'), quantity: 1 }] } });
  });
  let quantityTimer;
  const updateQuantity = (input) => {
    if (!input.isConnected || !input.validity.valid || input.value === '') return;
    const quantity = Math.max(0, Math.floor(Number(input.value) || 0));
    enqueue({ id: `quantity-${input.dataset.lineKey}`, action: 'change', payload: { id: input.dataset.lineKey, quantity } });
  };
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!input.matches('[data-cart-quantity]')) return;
    clearTimeout(quantityTimer);
    quantityTimer = setTimeout(() => updateQuantity(input), 350);
  });
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches('[data-cart-quantity]')) return;
    clearTimeout(quantityTimer);
    updateQuantity(input);
  });
})();
